export const createWrapperPaddings = (withSubtitle) => {
  if (withSubtitle) {
    return {
      paddingTop: {
        xs: '0',
        md: '0',
      },
    };
  }

  return {};
};
const styles = {
  title: {
    px: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: 'kit.text.main',
    textAlign: 'center',
    marginBottom: '16px',
    // lineHeight: {
    //   md: '44px',
    // },
  },
  subtitle: {
    mt: {
      xs: 0,
      md: 1,
    },
    display: 'inline-block',
    textAlign: 'center',
    color: 'kit.text.secondary',
    padding: '0 30px',
    marginBottom: {
      xs: '9px',
      md: '12px',
    },
  },
  formWrapper: {
    marginTop: '8px',
  },
  contentWrapper: {
    width: '100%',
    textAlign: 'center',
    position: 'relative',
  },
  message: {
    color: 'kit.text.secondary',
    marginBottom: '24px',
  },
  sent: {
    color: '#0F0F0F !important',
    minWidth: '124px',
    minHeight: '40px',
    marginBottom: '40px',
  },
  subscribe: {
    mt: 2,
    fontSize: {
      xs: '16px',
    },
    marginBottom: '24px',
  },
  sotial: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  iconLink: {
    marginRight: '24px',
    '&:last-child': {
      marginRight: '0',
    },
  },
  icon: {
    width: '1.75em',
    height: '1.75em',
  },
  error: {
    position: 'absolute',
    bottom: 0,
    transform: 'translateY(100%)',
    paddingTop: '4px',
    fontSize: '13px',
    lineHeight: '21px',
    color: 'kit.text.error',
    textAlign: 'center',
    width: '100%',
  },
};

export default styles;
